import configs from "./config";

const CloudfrontImageLoader = ({ src, width }) => {
  const DevicesWidthsMapper = {
    640: "250",
    750: "250",
    828: "300",
    1080: "300",
    1200: "350",
    1920: "350",
    2048: "350",
    3840: "350",
  };
  if (src.includes("http://") || src.includes("https://")) {
    return src;
  }
  return `${configs.IMAGES_BASE_URL}webp/${DevicesWidthsMapper[width]}x0/props/${src}`;
};
export default CloudfrontImageLoader;
